import { Modal } from "antd";

const FilePreviewModal = ({ open, onClose, file }) => {
  if (!file) return null;

  const isImage = file.isImage;
  const isPdf = file.isPdf;
  const isVideo = file.isVideo;
  const isOffice = file.isOffice;

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onClose}
      centered
      // width={600}
      width={isImage ? 600 : "70%"}
    >
      {isImage ? (
        <img
          src={file.url}
          alt={file.name}
          className="p-3"
          style={{ width: "100%" }}
        />
      ) : isPdf ? (
        <iframe
          src={file.url}
          title={file.name}
          width="100%"
          height="700"
          className="p-3"
          style={{ border: 0 }}
        />
      ) : isVideo ? (
        <video
          src={file.url}
          controls
          autoPlay={false}
          className="p-3"
          style={{
            width: "100%",
            maxHeight: "70vh",
            objectFit: "contain",
          }}
        >
          Your browser does not support video playback.
        </video>
      ) : isOffice ? (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file.url)}`}
          title={file.name}
          width="100%"
          height="700"
          className="p-3"
          style={{ border: 0 }}
        />
      ) : (
        <div className="p-3 text-center">
          <h5>Preview not available</h5>
          <p>
            File Type: <strong>{file.type?.toUpperCase()}</strong>
          </p>
        </div>
      )}
    </Modal>
  );
};

export default FilePreviewModal;
